import { Roles } from "@/helpers/enums/Roles";
import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Partner";

export default {
  get: (): any => {
    return axiosAgsc.post(
      `${resource}/Search`,
      {
        page: 1,
        pageSize: 9999,
        sortColumn: "name",
        sortDir: "asc",
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },
  getById: (partnerId: any = null): any => {
    return axiosAgsc.get(`${resource}/${partnerId}`, {});
  },
};
